module.exports = __webpack_public_path__ + "img/smile.fa4987f3.svg";